import React from 'react';
import Icon from 'components/AppIcon';

const CompanyHistory = () => {
  const historyData = {
    title: "Nuestra Historia",
    subtitle: "Our Journey",
    description: `BAC Pool CR nació en 2016 con la visión de brindar servicios de limpieza de piscinas de clase mundial en Costa Rica. Visítanos en bacpoolcr.online. Comenzamos como una empresa familiar pequeña con un enfoque simple: proporcionar un servicio excepcional que supere las expectativas de nuestros clientes.

A lo largo de los años, hemos crecido constantemente, expandiendo nuestro equipo y mejorando nuestros servicios. Hoy, somos una de las empresas de limpieza de piscinas más confiables en el área metropolitana de San José y sus alrededores.`,
    milestones: [
      {
        year: "2016",
        title: "Fundación de la Empresa",
        description: "Inicio de operaciones con 2 empleados y 15 clientes",
        icon: "Rocket"
      },
      {
        year: "2018",
        title: "Expansión de Servicios",
        description: "Incorporación de servicios de mantenimiento preventivo",
        icon: "Wrench"
      },
      {
        year: "2020",
        title: "Certificaciones Profesionales",
        description: "Obtención de certificaciones internacionales en mantenimiento de piscinas",
        icon: "Award"
      },
      {
        year: "2022",
        title: "Tecnología Avanzada",
        description: "Implementación de sistemas de monitoreo digital y aplicaciones móviles",
        icon: "Smartphone"
      },
      {
        year: "2024",
        title: "Liderazgo en el Mercado",
        description: "Más de 500 clientes satisfechos y expansión a nuevas provincias",
        icon: "Trophy"
      }
    ]
  };

  return (
    <section className="mb-16">
      <div className="text-center mb-12">
        <h2 className="text-3xl lg:text-4xl font-heading font-bold text-text-primary mb-4">
          {historyData.title}
        </h2>
        <p className="text-lg text-text-secondary font-medium mb-6">
          {historyData.subtitle}
        </p>
        <div className="max-w-4xl mx-auto prose prose-lg text-text-secondary">
          <p>{historyData.description}</p>
        </div>
      </div>

      {/* Timeline */}
      <div className="relative">
        {/* Timeline Line */}
        <div className="absolute left-1/2 transform -translate-x-1/2 w-1 bg-primary/20 h-full hidden lg:block"></div>
        
        <div className="space-y-8 lg:space-y-12">
          {historyData.milestones.map((milestone, index) => (
            <div key={index} className={`flex flex-col lg:flex-row items-center ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'}`}>
              {/* Content */}
              <div className={`w-full lg:w-5/12 ${index % 2 === 0 ? 'lg:text-right lg:pr-8' : 'lg:text-left lg:pl-8'}`}>
                <div className="bg-surface p-6 rounded-lg shadow-medium border border-border">
                  <div className="flex items-center space-x-3 mb-3 lg:justify-start">
                    <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                      <Icon name={milestone.icon} size={20} className="text-primary" />
                    </div>
                    <span className="text-2xl font-heading font-bold text-primary">
                      {milestone.year}
                    </span>
                  </div>
                  <h3 className="text-xl font-heading font-semibold text-text-primary mb-2">
                    {milestone.title}
                  </h3>
                  <p className="text-text-secondary">
                    {milestone.description}
                  </p>
                </div>
              </div>

              {/* Timeline Dot */}
              <div className="hidden lg:flex w-2/12 justify-center">
                <div className="w-4 h-4 bg-primary rounded-full border-4 border-surface shadow-medium"></div>
              </div>

              {/* Spacer */}
              <div className="hidden lg:block w-5/12"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CompanyHistory;
